import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Href } from "../../../../Constants/Constants";

const SmallSplitButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <ButtonGroup>
      <Btn outline color={"secondary"} size="sm">{"Small split button"}</Btn>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="down">
        <DropdownToggle color={"secondary"} size="sm">
          <i className="icofont icofont-arrow-down"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-content">
          <DropdownItem href={Href}>{"Action"}</DropdownItem>
          <DropdownItem href={Href}>{"Another action"}</DropdownItem>
          <DropdownItem href={Href}>{"Something else here"}</DropdownItem>
          <DropdownItem href={Href} divider></DropdownItem>
          <DropdownItem href={Href}>{"Separated link"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};

export default SmallSplitButton;
